import { Subscription } from 'rxjs';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener, KeyValueDiffers } from '@angular/core';
import {
  ObjectValueAccessor,
  CreateObjectValueAccessorProvider,
  CreateObjectValueValidationProvider,
} from '../../../shared/widgets/value-accessors/object-value-accessor';
import { ProfileAddress } from '../../shared/profileAddress.model';
import { ProfileService } from '../../shared/profile.service';
import { ActivatedRoute } from '@angular/router';
import { AddressTypeService } from 'src/app/admin/codes/shared/address-type.service';
import { AddressType } from 'src/app/admin/codes/shared/dto/address-type.model';

@Component({
  selector: 'wl-profile-edit-address',
  templateUrl: 'profile-edit-address.component.html',
  providers: [
    CreateObjectValueAccessorProvider(ProfileEditAddressComponent),
    CreateObjectValueValidationProvider(ProfileEditAddressComponent),
    AddressTypeService,
  ],
    standalone: false
})
export class ProfileEditAddressComponent extends ObjectValueAccessor<ProfileAddress> implements OnInit, AfterViewInit {
  public addressTypes: Array<AddressType>;

  public constructor(private _addressTypeService: AddressTypeService, private _profileService: ProfileService) {
    super({} as ProfileAddress, false);
  }

  public addressState = '';

  ngOnInit() {
    this._addressTypeService.getAddressTypes().then((data) => {
      this.addressTypes = data;
    });
  }

  ngAfterViewInit() {
    // Set pristine after Angular has initially set the model
    setTimeout(() => {
      this.addressState = this.value.State;
      this.setPristine();
    });
  }

  save(profileId: number) {
    let promise: Promise<void> = Promise.resolve();
    this.value.State = this.addressState;
    if (this.value.ID) {
      if (this.isDirty()) {
        promise = this._profileService.updateProfileAddress(this.value);
      }
    } else {
      this.value.ProfileID = profileId;
      promise = this._profileService.createProfileAddres(this.value).then((data) => {
        this.value.ID = data;
      });
    }
    return promise.then(() => this.setPristine());
  }
}
